import { render, staticRenderFns } from "./TutoriaDetalleNotasRegistro.vue?vue&type=template&id=1bd7e4b6&"
import script from "./TutoriaDetalleNotasRegistro.vue?vue&type=script&lang=js&"
export * from "./TutoriaDetalleNotasRegistro.vue?vue&type=script&lang=js&"
import style0 from "./TutoriaDetalleNotasRegistro.vue?vue&type=style&index=0&id=1bd7e4b6&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports